// extracted by mini-css-extract-plugin
module.exports = {"modal-image":"styles-module__modal-image___1t0yQ","modal":"styles-module__modal___1pdZW"};